import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import {
  FormErrorMessage,
  FormLabel,
  FormControl,
  Input,
  Button,
  Box,
  useToast,
} from '@chakra-ui/react';

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { HttpContext } from '../../context/HttpContext';
import { getErrors, getMessage } from '../../util';
import Currency from './SelectMultipleCurrency';

const SupplierIndividualForm = ({ onClose, addUser }) => {
  const [currencies, setCurrencies] = React.useState([]);
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('This is mandatory field'),
    lastName: Yup.string().required('This is mandatory field'),
    email: Yup.string()
      .required('This is mandatory field')
      .email('Please enter a valid email'),
  });
  const formOptions = {
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  };
  const { register, handleSubmit, formState, setError, reset } = useForm(formOptions);
  const { errors, isSubmitting, isDirty, isValid } = formState;
  const toast = useToast();
  const { authAxios } = useContext(HttpContext);

  const onSubmit = async (values) => {
    try {
      const selectedCurrencies = currencies.map((currency) => currency.id);
      const data = {
        ...values,
        currencies: selectedCurrencies,
        subType: 'individual',
      };

      const res = await authAxios.post(`users/suppliers`, data);
      toast({
        position: 'top',
        description:
          'You have successfully requested the supplier code. You will be notified when the finance team approves it.',
        status: 'success',
        duration: 6000,
        isClosable: true,
      });

      onClose();
      reset();
      addUser(res.data);
    } catch (onError) {
      console.log(onError);
      const errors = getErrors(onError);
      if (errors && errors.email && errors.email.errors) {
        const message = errors.email.errors[0];
        setError('email', { type: 'server', message });
      } else if (errors && errors.firstName && errors.firstName.errors) {
        const message = errors.firstName.errors[0];
        setError('firstName', { type: 'server', message });
      } else if (errors && errors.lastName && errors.lastName.errors) {
        const message = errors.lastName.errors[0];
        setError('lastName', { type: 'server', message });
      } else {
        const message = getMessage(onError);
        if (message) {
          toast({
            position: 'top-left',
            description: message,
            status: 'error',
            duration: 6000,
            isClosable: true,
          });
        }
      }
    }
  };

  const updateCurrencies = (currencies) => {
    setCurrencies(currencies);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl isInvalid={errors.firstName} mb={[4, 4, 8]}>
          <FormLabel htmlFor="emailHtmlFor">First Name</FormLabel>
          <Input
            isInvalid
            name="firstName"
            id="firstName"
            placeholder="Enter first name"
            focusBorderColor="black"
            errorBorderColor="error.500"
            {...register('firstName')}
          />
          <FormErrorMessage>
            {errors.firstName?.message || errors.firstName}
          </FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.lastName} mb={[4, 4, 8]}>
          <FormLabel htmlFor="emailHtmlFor">Last Name</FormLabel>
          <Input
            isInvalid
            name="lastName"
            id="lastName"
            placeholder="Enter last name"
            focusBorderColor="black"
            errorBorderColor="error.500"
            {...register('lastName')}
          />
          <FormErrorMessage>
            {errors.lastName?.message || errors.lastName}
          </FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={errors.email} mb={[4, 4, 8]}>
          <FormLabel htmlFor="emailHtmlFor">Email Address</FormLabel>
          <Input
            isInvalid
            name="email"
            id="email"
            placeholder="Enter email address"
            focusBorderColor="black"
            errorBorderColor="error.500"
            {...register('email')}
          />
          <FormErrorMessage>{errors.email?.message || errors.email}</FormErrorMessage>
        </FormControl>

        {/* <FormControl isInvalid={errors.currency} mb={[4, 4, 8]}>
          <FormLabel htmlFor="emailHtmlFor">Currency</FormLabel>
          <SelectCurrency updateCurrencyId={updateCurrencyId} />
          <FormErrorMessage>
            {errors.currency?.message || errors.currency}
          </FormErrorMessage>
        </FormControl> */}
        <Currency updateCurrencies={updateCurrencies} />
        <>
          <Box d="flex" justifyContent="flex-end" mt={20} mb={20}>
            <Button
              type="submit"
              size="lg"
              colorScheme="brand"
              disabled={!isDirty || !isValid || currencies.length === 0 || isSubmitting}
              isLoading={isSubmitting}
              textTransform="initial"
              _hover={{ bg: '#000' }}
              borderRadius="10px"
              mr="10px"
              //disabled={disableForm}
            >
              Submit
            </Button>
            <Button
              variant="ghost"
              size="lg"
              colorScheme="brand"
              // isLoading={isSubmitting}
              textTransform="initial"
              borderRadius="10px"
              onClick={onClose}
              // _hover={{ bg: "#000" }}
            >
              Cancel
            </Button>
          </Box>
        </>
      </form>
    </>
  );
};
export default SupplierIndividualForm;
